import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.VUE_APP_API_BASE_URL;

export default {
  getInventory(params = {}) {
    return axios.get(`${API_URL}/shopify-ve/inventory`, {
      headers: authHeader(),
      params,
    });
  },
  getPosProducts(params = {}) {
    return axios.get(`${API_URL}/shopify-ve/inventory`, {
      headers: authHeader(),
      params,
    });
  },
  getOrders(params = {}) {
    return axios.get(`${API_URL}/shopify-ve/orders`, {
      headers: authHeader(),
      params,
    });
  },
  syncProducts() {
    return axios.post(`${API_URL}/shopify-ve/products/sync`, {}, { headers: authHeader() });
  },
  pushToShopify() {
    return axios.post(`${API_URL}/shopify-ve/products/push`, {}, { headers: authHeader() });
  },
  pushProductToShopify(productId) {
    return axios.post(`${API_URL}/shopify-ve/products/${productId}/push`, {}, { headers: authHeader() });
  },
  generateToken(payload = {}) {
    return axios.post(`${API_URL}/shopify-ve/oauth/token`, payload, { headers: authHeader() });
  },
  uploadProductImage(productId, file) {
    const formData = new FormData();
    formData.append("image", file);
    return axios.post(`${API_URL}/shopify-ve/inventory/${productId}/image`, formData, {
      headers: { ...authHeader(), "Content-Type": "multipart/form-data" },
    });
  },
};
